<template>
    <div :class="`single-features-item ${style_2 ? 'b-radius-2' : 'b-radius'} mb-20`">
        <div class="row g-0 align-items-center">
            <div class="col-6">
                <div class="features-thum">
                    <div class="features-product-image w-img">
                        <router-link :to="`/product-details/${product.product_id}`">
                          <img style="width:120px;" :src="product.image" alt="product-img">
                        </router-link>
                    </div>
                    <div class="product__offer" v-if="product.special_discount_percentage">
                      <span class="discount">-{{ product.special_discount_percentage }}%</span>
                  </div>
                </div>
            </div>
            <div class="col-6">
                <div class="product__content product__content-d">
                    <h6><router-link :to="`/product-details/${product.product_id}`">{{ product.title }}</router-link></h6>
                    <!-- <div class="rating mb-5">
                        <ul>
                            <li><a href="#"><i class="fal fa-star"></i></a></li>
                            <li><a href="#"><i class="fal fa-star"></i></a></li>
                            <li><a href="#"><i class="fal fa-star"></i></a></li>
                            <li><a href="#"><i class="fal fa-star"></i></a></li>
                            <li><a href="#"><i class="fal fa-star"></i></a></li>
                        </ul>
                        <span>({{ product.reviews.length }} review)</span>
                    </div> -->
                    <div class="price d-price">
                        <span>LKR {{ product.price }} - <del>LKR{{ calculateOriginalPrice(product.price, product.special_discount_percentage).toFixed(2) }}</del></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

<script>
import { useCartStore } from "@/stores/useCartStore";
import { calculateOriginalPrice } from "@/utils/utils";

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cartStore: useCartStore(),
      calculateOriginalPrice
    };
  },
  methods: {
    
  },
};
</script>
  